export const iconFontAwesomeCommunicationMobileButton = (
	<i className="fa-solid fa-mobile-button"></i>
);
